import moment from './moment'

import constants from '../../config/constants'

/**
 * Format date from frontEnd format to the backEnd format
 * @param {String} date
 * @returns {String}
 */
export default date =>
  moment(date, constants.frontEndDateFormat, true).format(
    constants.backEndDateFormat
  )
